/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardMembershipFeeController', BoardMembershipFeeController);

    BoardMembershipFeeController.$inject = ['$state', 'MembershipFee', 'MembershipFeeSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$http', 'entity', '$stateParams'];

    function BoardMembershipFeeController($state, MembershipFee, MembershipFeeSearch, ParseLinks, AlertService, paginationConstants, pagingParams, $http, entity, $stateParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.getUser = getUser;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.select = pagingParams.select;
        vm.selected = null;
        vm.selectUser = selectUser;

        loadAll();

        function loadAll () {
            if(entity != null) {
                vm.selected = entity.user.firstName + " " + entity.user.lastName + (entity.nickname ? (' "' + entity.nickname + '"') : (''));
            }
            if (pagingParams.search) {
                MembershipFeeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MembershipFee.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    profileID: $stateParams.select
                }, onSuccess, onError);
            }
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate === 'dept.paymentStatus') {
                    result.push('dept.sepa');
                }
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.membershipFees = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                select: vm.select
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.select = null;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'year';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.select = null;
            vm.transition();
        }

        function getUser(val) {
            return $http.get('api/_search/profiles/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }

        function selectUser(item, model) {
            vm.select = model.id;
            vm.transition();
        }
    }
})();
